var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/expand_more_24px copy 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_408_5648",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 6,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/expand_more_24px",
    d: "M12.5004 6.77083L9.26707 10.0042L12.5004 13.2375C12.6564 13.3932 12.7441 13.6046 12.7441 13.825C12.7441 14.0454 12.6564 14.2568 12.5004 14.4125C12.1754 14.7375 11.6504 14.7375 11.3254 14.4125L7.5004 10.5875C7.1754 10.2625 7.1754 9.7375 7.5004 9.4125L11.3254 5.5875C11.6504 5.2625 12.1754 5.2625 12.5004 5.5875C12.8171 5.9125 12.8254 6.44583 12.5004 6.77083Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_408_5648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 20,
    height: 20,
    transform: "matrix(0 -1 -1 0 20 20)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.a54875914ea9ae33c465e2c18fecf818.svg";
export { ForwardRef as ReactComponent };